
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatMenuModule } from '@angular/material/menu';
import { TranslateModule } from '@ngx-translate/core';
import { InviteUsersDialogModule } from '@go-modules/components/dialogs/invite-users-dialog/invite-users-dialog.module';
import { OrgMenuComponent } from './org-menu.component';

@NgModule({
	imports: [
		CommonModule,
		TranslateModule,
		MatMenuModule,
		InviteUsersDialogModule
	],
	declarations: [
		OrgMenuComponent
	],
	exports: [
		OrgMenuComponent
	]
})
export class OrgMenuModule {}
